// extracted by mini-css-extract-plugin
export var cartCount = "cart-icon-module--cartCount--14d0a";
export var cartIcon = "cart-icon-module--cartIcon--bf08b";
export var cartIconImage = "cart-icon-module--cartIconImage--357a0";
export var center = "cart-icon-module--center--8b0a7";